@if (resAsync | async) {
  <div #controllerContainer class="moveNodeController">
    <button mat-icon-button class="buttonCancel" (click)="cancel()">
      <mat-icon [svgIcon]="res.svgName('Close-Image')"></mat-icon>
    </button>
    <p class="helpText">{{ res.get('Controls-MoveNode-HelpText') }}</p>
    <button (click)="cancel()" class="buttonReady">{{ res.get('Controls-MoveNode-Cancel') }}</button>
  </div>
}
